import http from "./http_common";

class PharmaAndLabOrderService {
  queryString(payload) {
    const QueryString = Object.keys(payload)
      .map((key) => key && payload[key] && key + "=" + payload[key])
      .join("&");
    return QueryString;
  }

  GetPharmacyList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/userPharmacyMap/list/filter?${queryString}`);
  }

  GetDispensedDrugsDtl(payload) {
    const queryString = this.queryString(payload);
    return http.get(
      `/dispensedDrugsDtl/prescriptionforpharmacy?${queryString}`
    );
  }

  SharePharmaLabAPI(payload) {
    return http.post(`/consultation/share-Eprescription/pharmaandlab`, payload);
  }

  GetLabTestOrderDtl(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderDtl/prescriptionforlab?${queryString}`);
  }

  GetLabList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/userLabMap/list/filter?${queryString}`);
  }

  getMedicineOrdersList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/dispensedDrugsHdr/list/filter?${queryString}`);
  }

  getMedicineOrder(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/dispensedDrugsDtl/list/filter?${queryString}`);
  }

  cancelMedicineOrder(payload) {
    return http.put("/dispensedDrugsHdr/cancel/medicine-orders", payload);
  }

  getLabOrdersList(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderHdr/get/list/lab?${queryString}`);
  }

  getLabOrder(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderDtl/list/filter?${queryString}`);
  }

  labOrderCancel(payload) {
    return http.put("/labTestOrderHdr/cancel/lab-orders", payload);
  }

  LabListGet(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/labTestOrderResult/list/filter?${queryString}`);
  }
}

export default new PharmaAndLabOrderService();
